import React from 'react'

import { Link } from 'react-router-dom';

import { Section, ActivityFeed, Firmware, SensorStatus } from 'components';
import { Dropdown, Container, Icon } from 'semantic-ui-react';

//--Constants
const MAX_ACTIVITY = 5;

class PaneActivity extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: ActivityFeed.FILTER_NONE,
    };

    this.handleFilter = this.handleFilter.bind(this);
  }

  handleFilter(event, { value }) {

    this.setState({
      filter: value
    });
  }

  getActivityMapping() {

    return ActivityFeed.Mapping([

      // Synchronization
      {
        type: 'SYNC',
        name: 'Synchronisation',
        content: (payload) => {

          return {
            icon: 'sync',
            content: 'Le capteur vient de se synchroniser avec succès',
          }
        }
      },

      // Update
      {
        type: 'UPDATE',
        name: 'Mise à jour',
        content: (payload) => {

          return {
            icon: <Icon name = "check circle" color = "green" />,
            content: (
              <React.Fragment>
                Le firmware <Firmware firmware={payload.firmware} /> vient d'être installé sur le capteur
              </React.Fragment>
            )
          };
        }
      },

      // Association
      {
        type: 'ASSOCIATE',
        name: 'Association',
        content: (payload) => {

          return {
            icon: 'linkify',
            content: (
              <React.Fragment>
                Le capteur vient d'être associé à la valise <Link to={`/devices/${payload.device}`}>#{payload.device}</Link>
              </React.Fragment>
            )
          }
        }
      },

      // Dissociation
      {
        type: 'DISSOCIATE',
        name: 'Dissociation',
        content: (payload) => {

          return {
            icon: 'unlink',
            content: (
              <React.Fragment>
                Le capteur vient d'être dissocié de la valise <Link to={`/devices/${payload.device}`}>#{payload.device}</Link>
              </React.Fragment>
            )
          }
        }
      },

      // Status
      {
        type: 'STATUS',
        name: "Changement d'état",
        content: (payload) => {

          return {
            icon: 'sync',
            content: (
              <React.Fragment>
                L'état du capteur a été mis à jour en <SensorStatus status={payload.status} />
              </React.Fragment>
            )
          }
        }
      },
    ]);
  }

  render() {

    const { sensor } = this.props;

    const mapping = this.getActivityMapping();

    return (
      <Container>

        <Section title="Activité récente" collapsible actions={[
          <Dropdown icon="filter" value={this.state.filter} options={mapping.getFilters()} onChange={this.handleFilter} direction='left' key={0} />,
        ]}>

          {/* Feed */}
          <ActivityFeed filter={this.state.filter} mapping={mapping} route={`/sensors/${sensor.mac_address}/activities`} max={MAX_ACTIVITY} />

        </Section>

      </Container>
    )
  }
}

export default PaneActivity;
